// sagas/planoSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchPlanosStart, fetchPlanosSuccess, fetchPlanosFailure, fetchOpcoesStart, trocarPlano, trocarPlanoSuccess, trocarPlanoFailure, consultarAssinaturaSuccess, consultarAssinatura } from '../reducers/plano';
import { api } from '../../services/api';
import { enviarDadosSuccess, salvarDadosAction } from '../reducers/utils';

function* fetchPlanosSaga() {
    try {
        const form = new FormData();
        form.append('paginacao', -1);
        form.append('pagina', 0);

        const response = yield call(api.post, '/PlanoAssinatura/ListarPlano', form);
        yield put(fetchPlanosSuccess(response.data.dados.lista));
    } catch (error) {
        yield put(fetchPlanosFailure(error.toString()));
    }
}

function* fetchTrocarPlano(action) {
    try {
        const form = new FormData();
        Object.keys(action.payload).forEach(key => {
            form.append(key, action.payload[key]);
        });

        const xtoken = localStorage.getItem('@xtoken');
        
        const config = {
            headers: {
                'x-token': `${xtoken}`, 
            }
        };

        const response = yield call(api.post, '/Assinatura/AlterarPlano', form, config);

        if (!response.data.sucesso) {
            yield put(trocarPlanoFailure(response.data.erro));
        } else {
            yield put(trocarPlanoSuccess(response.data));
            yield put(enviarDadosSuccess(response.data.dados));
        }
    } catch (error) {
        console.log(error);
    }
}


function* consultarAssinaturaRequest(action) {
    try {
        const form = new FormData();
        Object.keys(action.payload).forEach(key => {
            form.append(key, action.payload[key]);
        })
        const response = yield call(api.post, '/Assinatura/ConsultarAssinatura', form);
        yield put(consultarAssinaturaSuccess(response.data));
        yield put(salvarDadosAction(response.data.dados));
    } catch (error) {

        console.log(error);
    }
}

function* planoSaga() {
    yield takeLatest(fetchPlanosStart.type, fetchPlanosSaga);
    yield takeLatest(fetchOpcoesStart.type, fetchPlanosSaga);
    yield takeLatest(trocarPlano.type, fetchTrocarPlano);
    yield takeLatest(consultarAssinatura.type, consultarAssinaturaRequest);
}

export default planoSaga;
